module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-section"
  }, [(_vm.title || _vm.$slots.toolbar) ? _c('div', {
    staticClass: "rt-section__header"
  }, [_c('div', {
    staticClass: "rt-section__title"
  }, [(_vm.iconName) ? _c('div', {
    staticClass: "rt-section__icon"
  }, [_c('rt-portal-icon', {
    attrs: {
      "name": _vm.iconName,
      "color": "#fff",
      "size": "16"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('rt-toolbar', [_vm._t("toolbar")], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCollapsed),
      expression: "!isCollapsed"
    }],
    staticClass: "rt-section__content"
  }, [_vm._t("default")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ff23f90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/section/src/main.vue
// module id = 2140
// module chunks = 137